import { VehicleCategory } from '~/shared/api'
import { Filter } from '~/shared/ui/AsyncGrid/types'

export const filters: Filter[] = [
  {
    field: 'title',
    label: 'filter.name',
    type: 'text',
  },
  {
    field: 'vehicleCategory',
    label: 'filter.vehicle category',
    type: 'autocomplete',
    fetchOptions: VehicleCategory.fetchOptions,
  },
  {
    field: 'active',
    label: 'filter.active',
    type: 'boolean',
  },
  {
    field: 'isPromotion',
    label: 'filter.car is in promotion',
    type: 'boolean',
  },
]
